export default tokenJson => {
    // const token = JSON.parse(tokenJson);
    // const jwt = JSON.parse(atob(token.split(".")[1]));
    const jwt = atob(tokenJson.split(".")[1]);

    return jwt;

}